<template>

  <div
    class="
      grid grid-cols-6
      layout-padding
      lg:gap-x-32
      md:gap-x-16
      gap-x-0 gap-y-5
    "
  >
    <div
      class="col-span-6 md:col-span-3 lg:col-span-2 animate-painting"
      v-for="(work, index) in 9"
      :key="index"
      :class="
        index % 2 == 0
          ? `lg:mt-10 even animate-painting-${index}`
          : `odd animate-painting-odd-${index}`
      "
    >
            <div class="h-[350px] w-full bg-primary"></div>

    </div>
 
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  inject: ["content"],



  methods: {

    animate() {
      if (screen.width > 1024 || screen.width < 768) {
        for (let s = this.oldLength; s < this.works.length; s++) {
          gsap.to(`.animate-painting-${s}`, {
            y: "-30%",
            scrollTrigger: {
              trigger: `.animate-painting-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
          gsap.to(`.animate-painting-odd-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-painting-odd-${s}`,
              start: "top top",
              end: "500",
              scrub: 1,
            },
          });
        }
      } else {
        for (let s = this.oldLength; s < this.works.length; s++) {
          gsap.to(`.animate-painting-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-painting-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
          gsap.to(`.animate-painting-odd-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-painting-odd-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
        }
      }
    },
  },

};
</script>